import React from "react"
import { Alert } from "reactstrap"

const CustomAlert = (props) => {
  return <Alert {...props} fade={false} />
}

export default CustomAlert
